import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./StatusBadge.scss";

export type BadgeVariant = "green" | "blue" | "amber" | "red" | "gray" | "gold" | "secondary" | "purple" | "teal" | "orange";

interface StatusBadgeProps {
  variant: BadgeVariant;
  icon?: IconDefinition;
  label: string;
  solid?: boolean;
  size?: 'sm';
  onClick?: () => void;
  selected?: boolean;
}

export function StatusBadge({ variant, icon, label, solid, size, onClick, selected }: StatusBadgeProps) {
  const isInteractive = onClick !== undefined;
  const isUnselected = isInteractive && selected === false;

  const baseClass = [
    'status-badge',
    `status-badge--${variant}`,
    solid ? 'status-badge--solid' : '',
    size === 'sm' ? 'status-badge--sm' : '',
    isInteractive ? 'status-badge--interactive' : '',
    isUnselected ? 'status-badge--unselected' : '',
    'd-inline-flex align-items-center rounded-pill border',
  ].filter(Boolean).join(' ');

  if (isInteractive) {
    return (
      <button type="button" className={baseClass} onClick={onClick}>
        {icon && <FontAwesomeIcon icon={icon} className="me-1" />}
        {label}
      </button>
    );
  }

  return (
    <span className={`${baseClass} fw-bold`}>
      {icon && <FontAwesomeIcon icon={icon} className="me-1" />}
      {label}
    </span>
  );
}
